import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { ReduxControls } from "rhombus-react";

import "./CheckboxDisplay.css";

export default function CheckboxDisplay({ dependentValues = {} }) {
	const { rowIndex, disabled = false } = dependentValues;

	return (
		<div className="checkbox-display-container">
			<Field
				component={ReduxControls.Checkbox}
				type="checkbox"
				name={`${rowIndex}.allowEmpty`}
				className="custom-checkbox"
				disabled={disabled}
				onKeyDown={event => event.stopPropagation()}
			/>
		</div>
	);
}

CheckboxDisplay.displayName = "CheckboxDisplay";

CheckboxDisplay.propTypes = {
	dependentValues: PropTypes.shape({
		rowIndex: PropTypes.number,
		disabled: PropTypes.bool,
	}),
};
